/* eslint-disable @typescript-eslint/ban-ts-comment */
// @flow
import FormikDateField from 'components/formik/FormikDateField'
import FormikPhoneField from 'components/formik/FormikPhoneField'
import FormikTextAreaField from 'components/formik/FormikTextAreaField'
import FormikTextField from 'components/formik/FormikTextField'
import FormikTimeField from 'components/formik/FormikTimeField'
import { useLoadCustomerFields } from 'queries/customerFields/useLoadCustomerField'
import * as React from 'react'

type Props = {
  isEditMode: boolean
}

function ClientDemographicsTableCustomFields({ isEditMode }: Props) {
  const { data, isLoading } = useLoadCustomerFields()

  if (isLoading) {
    return null
  }

  return (
    <div className="grid grid-cols-12 gap-x-6 gap-y-4 pt-1">
      {data?.map((field) => {
        if (
          [
            'text#single_line',

            'text#email',
            'text#full_name',
            'number#number',
          ].includes(field.type)
        ) {
          return (
            <div className="col-span-12 md:col-span-4">
              <FormikTextField
                disabled={!isEditMode}
                label={field.label}
                name={`custom_fields.${field.name}`}
                placeholder={field.label}
                type={field.type === 'text#email' ? 'email' : 'text'}
              />
            </div>
          )
        }
        if (field.type === 'text#multi_line') {
          return (
            <div className="col-span-12 md:col-span-4">
              <FormikTextAreaField
                // @ts-ignore
                disabled={!isEditMode}
                label={field.label}
                name={`custom_fields.${field.name}`}
                placeholder={field.label}
              />
            </div>
          )
        }
        if (field.type === 'text#phone') {
          return (
            <div className="col-span-12 md:col-span-4">
              <FormikPhoneField
                // @ts-ignore
                disabled={!isEditMode}
                label={field.label}
                name={`custom_fields.${field.name}`}
                placeholder={field.label}
              />
            </div>
          )
        }
        if (field.type === 'datetime#time_only') {
          return (
            <div className="col-span-12 md:col-span-4">
              <FormikTimeField
                // @ts-ignore
                disabledGrayed
                // @ts-ignore
                disabled={!isEditMode}
                label={field.label}
                name={`custom_fields.${field.name}`}
                placeholder={field.label}
              />
            </div>
          )
        } else if (field.type.startsWith('datetime')) {
          return (
            <div className="col-span-12 md:col-span-4">
              <FormikDateField
                // @ts-ignore
                disabledGrayed
                // @ts-ignore
                disabled={!isEditMode}
                label={field.label}
                name={`custom_fields.${field.name}`}
                picker={field.type === 'datetime#month_year' ? 'month' : null}
                placeholder={field.label}
                showTime={field.type === 'datetime#datetime'}
              />
            </div>
          )
        }
        return null
      })}
    </div>
  )
}

export default ClientDemographicsTableCustomFields
